import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Slide1Overview() {
  const metrics = [{
    label: 'Total Participants Engaged',
    value: '73'
  }, {
    label: 'Active Respondents',
    value: '41'
  }, {
    label: 'Qualified Leads Generated',
    value: '12'
  }];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full pt-10" data-id="element-536">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="mb-12" data-id="element-537">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-snakker-soft text-snakker-purple font-bold text-sm mb-6 border border-snakker-purple/20" data-id="element-538">
          <CheckCircle2 className="w-4 h-4" data-id="element-539" />
          Exceptional Success Ready for Strategic Expansion
        </div>
        <div className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-3" data-id="element-540">
          Campaign Performance Report
        </div>
        <h1 className="text-5xl md:text-7xl font-display font-bold text-slate-900 mb-6 leading-tight" data-id="element-541">
          Minerva Congress 2026 <br data-id="element-542" />
          <span className="text-minerva-blue" data-id="element-543">Executive Summary</span>
        </h1>
        <p className="text-xl text-slate-500 max-w-3xl leading-relaxed" data-id="element-544">
          A single congress event campaign that delivered outstanding results
          across lead generation, brand engagement, and market intelligence.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-auto" data-id="element-545">
        {metrics.map((metric, i) => <motion.div key={i} initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4 + i * 0.1
      }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 flex flex-col items-center justify-center text-center hover:shadow-md transition-shadow border-t-4 border-t-minerva-blue" data-id="element-546">
            <div className="text-6xl font-bold text-slate-900 mb-3" data-id="element-547">
              {metric.value}
            </div>
            <div className="text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-548">
              {metric.label}
            </div>
          </motion.div>)}
      </div>
    </div>;
}